



export function alertas({
  type = "info",        // info | success | warning | error
  title = "Notice",
  message = "",
  buttonText = "OK",
  onConfirm = null,
  redirect = null
}) {

  // eliminar popup previo
  const old = document.getElementById("iosPopupOverlay");
  if (old) old.remove();

  // colores por tipo
  const COLORS = {
    info:    "#007AFF",
    success: "#34C759",
    warning: "#FF9F0A",
    error:   "#FF3B30"
  };

  const BTN_COLOR = COLORS[type] || COLORS.info;

  // estilos (solo se insertan una vez)
  if (!document.getElementById("iosAlertStyle")) {
    const style = document.createElement("style");
    style.id = "iosAlertStyle";
    style.innerHTML = `
      #iosPopupOverlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        backdrop-filter: blur(6px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2147483647;
        animation: fadeIn 0.2s ease-out;
      }

      #iosPopupCard {
        position: relative;
        background: #fff;
        width: 85%;
        max-width: 360px;
        padding: 26px 22px 22px;
        border-radius: 18px;
        text-align: center;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto;
        animation: slideUp 0.25s ease-out;
      }

      #iosPopupCard h2 {
        margin: 0 0 10px;
        font-size: 20px;
        font-weight: 600;
        color: #111;
      }

      #iosPopupCard p {
        font-size: 16px;
        color: #444;
        line-height: 1.35;
      }

      .iosBtn {
        margin-top: 18px;
        color: #fff;
        padding: 12px;
        width: 100%;
        border-radius: 12px;
        border: none;
        font-size: 16px;
        cursor: pointer;
        font-weight: 500;
      }

      .iosCloseBtn {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(0,0,0,0.08);
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
        color: #333;
        user-select: none;
      }

      .iosCloseBtn:hover {
        background: rgba(0,0,0,0.15);
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from { transform: translateY(40px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // overlay
  const overlay = document.createElement("div");
  overlay.id = "iosPopupOverlay";

  // card
  const card = document.createElement("div");
  card.id = "iosPopupCard";

  // close
  const closeBtn = document.createElement("div");
  closeBtn.className = "iosCloseBtn";
  closeBtn.innerHTML = "✕";
  closeBtn.onclick = () => overlay.remove();

  // content
  card.innerHTML = `
    <h2>${title}</h2>
    <p>${message}</p>
  `;

  // button
  const button = document.createElement("button");
  button.className = "iosBtn";
  button.style.background = BTN_COLOR;
  button.innerText = buttonText;

  button.onclick = () => {
      overlay.remove();

      if (typeof onConfirm === "function") {
        onConfirm();
      }

      if (redirect) {
        location.href = redirect;
      }
    };

  card.appendChild(closeBtn);
  card.appendChild(button);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
}






export function alert_error(message){


const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.top = '20%';
    popup.style.left = '50%';
    popup.style.transform = 'translateX(-50%)';
    popup.style.backgroundColor = '#ff4d4d';
    popup.style.color = '#fff';
    popup.style.padding = '20px';
    popup.style.borderRadius = '8px';
    popup.style.boxShadow = '0 2px 10px rgba(0,0,0,0.3)';
    popup.style.zIndex = '1000';
    popup.style.maxWidth = '300px';
    popup.style.textAlign = 'center';
    popup.style.fontFamily = 'Arial, sans-serif';

    // Mensaje de error
    const msg = document.createElement('span');
    msg.innerHTML = message;
    popup.appendChild(msg);

    // Botón de cerrar
    const closeBtn = document.createElement('button');
    closeBtn.innerText = 'Cerrar';
    closeBtn.style.marginTop = '10px';
    closeBtn.style.background = '#fff';
    closeBtn.style.color = '#ff4d4d';
    closeBtn.style.border = 'none';
    closeBtn.style.padding = '5px 10px';
    closeBtn.style.borderRadius = '5px';
    closeBtn.style.cursor = 'pointer';
    closeBtn.onclick = () => document.body.removeChild(popup);

    popup.appendChild(document.createElement('br'));
    popup.appendChild(closeBtn);

    document.body.appendChild(popup);

    // Opcional: auto-cierre después de 5 segundos
    setTimeout(() => {
      if (document.body.contains(popup)) {
        document.body.removeChild(popup);
      }
    }, 5000);



}
